import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Component as BrComponent, Page, Document } from '@bloomreach/spa-sdk';
import { Constant } from '../../ft-constants/constant';
import { Location } from '@angular/common';

@Component({
  selector: 'ft-jump-links-content',
  templateUrl: './jump-links-content.component.html',
  styleUrls: ['./jump-links-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class JumpLinksContentComponent implements OnInit {
  @Input() component!: BrComponent;
  @Input() page!: Page;
  constructor() {}

  ngOnInit(): void {}
  get document() {
    const { document } = this.component?.getModels<DocumentModels>() || {};
    const content = document && this.page?.getContent<Document>(document);
    return content;
  }
  get content() {
    return this.document?.getData();
  }
  get jumpList() {
    return this.modifyList(this.content.jumpLinkContent);
  }
  modifyList(data) {
    for (let i = 0; i < data.length; i++) {
      data[i].leftContentDesc = data[i].leftContentDesc.split('\r\n');
    }
    return data;
  }
  getImg(elem) {
    let imageUrl = '';
    if (elem.widenDocument && elem.widenDocument !== '') {
      imageUrl = JSON.parse(elem.widenDocument).url ? JSON.parse(elem.widenDocument).url : '';
    }
    return imageUrl;
  }
}
